import { Component, Input } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-need-help',
  templateUrl: './need-help.component.html',
  styleUrls: ['./need-help.component.scss']
})
export class NeedHelpComponent {
  @Input() webView?: any;
  receivedData: any;
  constructor(private location: Location, private route: ActivatedRoute){
    this.route.params.subscribe(params => {
      this.receivedData = history.state;
    });
  }
  goBack(){
    this.location.back();
  }
}
